import { ReferenceInput, SelectInput, TextInput, required } from 'react-admin';

import { useFormLanguage } from '@app/hooks/useFormLanguage';
import { Grid, Typography } from '@mui/material';

import { LanguageSelector } from '@app/components/common/LanguageSelector';
import { MultiLingualField } from '@app/components/common/MultiLingualField';

export const EditUserForm = () => {
  const { language, handleChangeLanguage } = useFormLanguage();

  return (
    <div>
      <Typography data-cy={`edit-user-form`} variant="h3" sx={{ marginBottom: 2 }}>
        {'EDIT USER'}
      </Typography>
      <LanguageSelector language={language} handleChangeLanguage={handleChangeLanguage} />
      <Grid spacing={2} container>
        <Grid item xs={12}>
          <MultiLingualField
            Component={TextInput}
            language={language}
            source="name"
            label="Name"
            variant="outlined"
            fullWidth
            helperText="Maximum 60 characters"
            validate={[required()]}
            inputProps={{ maxLength: 60 }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextInput variant="outlined" helperText={false} label="Email Address" source="email" fullWidth disabled />
        </Grid>
        <Grid item xs={6}>
          <ReferenceInput source="role" reference="users/roles">
            <SelectInput
              label="Role"
              variant="outlined"
              helperText={false}
              validate={required()}
              fullWidth
              optionText={(record) => record.description}
            />
          </ReferenceInput>
        </Grid>
      </Grid>
    </div>
  );
};
